import { render } from "./FormRow.vue?vue&type=template&id=3d0881e8&scoped=true"
const script = {}

import "./FormRow.vue?vue&type=style&index=0&id=3d0881e8&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0881e8"]])

export default __exports__